export default __webpack_public_path__ + "static/media/kitchen-1.08d66b0d.jpg";